const SectionTitle = ({
  title,
  subtitle,
  paragarap,
  paragraphStyle,
  isLightBg,
  titleStyle,
}) => {
  return (
    <div
      className="section-title"
      style={{ textAlign: "center", marginBottom: "50px" }}
    >
      {subtitle && <span>{subtitle}</span>}
      <h2
        style={{
          fontSize: "45px",
          fontWeight: "bold",
          color: "#242583",
          marginBottom: "20px",
          textAlign: "center",
          ...titleStyle,
        }}
      >
        {title}
      </h2>
      {paragarap && (
        <p
          style={{
            color: isLightBg ? "#666" : "white",
            fontSize: "18px",
            lineHeight: "1.6",
            maxWidth: "900px",
            margin: "0 auto",
            ...paragraphStyle,
          }}
        >
          {paragarap}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
